import { render, staticRenderFns } from "./ptomAgentInfo-set.vue?vue&type=template&id=34b1c640&scoped=true"
import script from "./ptomAgentInfo-set.vue?vue&type=script&lang=js"
export * from "./ptomAgentInfo-set.vue?vue&type=script&lang=js"
import style0 from "./ptomAgentInfo-set.vue?vue&type=style&index=0&id=34b1c640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1c640",
  null
  
)

export default component.exports